import React from 'react'
import Box from '@mui/material/Box'
import { EmtChip, EmtIcon, EmtTypography, useMobile } from 'emt-components-v2'
import { LightBox, LightBoxChips } from './StyledComponents'
import { useEMTState } from '@/store'
import { GenericProfile } from '@/dataV3/GenericProfile'

type Props = React.PropsWithChildren<{
  profile: Pick<GenericProfile, 'displayName' | 'memberOptions'>
}>

const Have: React.FC<Props> = ({ profile: { displayName, memberOptions } }) => {
  const [isMobile, isTablet] = useMobile()
  const { types: haveDisponibilityChoiceTypes, sentence } =
    useEMTState().configuration.disponibilityChoices.find((dc) => dc.slug === 'have') || {}

  const haveDisponibilitySentence = sentence?.borrowerSentence.profileSentence.replaceAll('{{first_name}}', displayName)

  return (
    <Box sx={{ display: 'flex', flexDirection: isMobile || isTablet ? 'column' : 'row', gap: '24px' }}>
      <LightBox>
        <EmtTypography variant="h5" fontWeight={700}>
          {haveDisponibilitySentence}
        </EmtTypography>
        <LightBoxChips>
          <Box>
            {haveDisponibilityChoiceTypes?.map((haveObject, key) => (
              <EmtChip
                key={key}
                variant={memberOptions[haveObject.slug] ? 'filled' : 'disabled'}
                color={memberOptions[haveObject.slug] ? 'successlight' : 'greylight'}
                label={haveObject.sentence.borrowerSentence.profileSentence}
                icon={<EmtIcon className={haveObject.icon?.className} sx={{ fontWeight: 100 }} />}
              />
            ))}
          </Box>
        </LightBoxChips>
      </LightBox>
    </Box>
  )
}

export default Have
